var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonFilterPointingDown01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.226,
    height: 5.597,
    viewBox: "0 0 8.226 5.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3.474,3.488,0,6.811,3.337",
    transform: "translate(7.52 4.183) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFilterPointingDown01);
export default __webpack_public_path__ + "static/media/Button-Filter-PointingDown-01.f3b34bdd01d7b6cc84987c9795a596a4.svg";
export { ForwardRef as ReactComponent };